import b from 'b_';
import React from 'react';

import './certificate-modal__column.scss';

interface Props {
    type: 'conditions' | 'form';
    children: React.ReactNode | Array<React.ReactNode>;
}

export const CertificateModalColumn = ({ type, children }: Props) => (
    <div className={b('certificate-modal', 'column', { type })}>{children}</div>
);
